export default __webpack_public_path__ + "static/media/es.1e96d441.svg";